/// <reference types="vite/client" />

const config = {
  apiURL: import.meta.env.VITE_API_URL,
  chatApiURL: import.meta.env.VITE_CHAT_API_URL,
  shopify: {
    clientId: import.meta.env.VITE_SHOPIFY_CLIENT_ID,
    redirect: import.meta.env.VITE_SHOPIFY_REDIRECT,
    scope:
      'write_orders,write_draft_orders,write_fulfillments,write_inventory,write_products,write_assigned_fulfillment_orders,write_third_party_fulfillment_orders,write_returns,read_locations',
  },
  hellosign: {
    clientId: import.meta.env.VITE_HELLOSIGN_CLIENT_ID,
    skipDomainVerification: import.meta.env.VITE_HELLOSIGN_SKIP_DOMAIN_VERIFICATION === 'true',
  },
  isDevelopment: import.meta.env.VITE_ENV === 'development',
  // Dev-only escape hatch: serves the Payouts tab from local fixtures while GET /payouts
  // is still unmerged on the backend (MAK-608). Gated on development as well as the flag
  // so it cannot be switched on in a staging or production build.
  useMockPayouts:
    import.meta.env.VITE_ENV === 'development' && import.meta.env.VITE_MOCK_PAYOUTS === 'true',
  isStaging: import.meta.env.VITE_ENV === 'staging',
  isProduction: import.meta.env.VITE_ENV === 'production',
  isTest: import.meta.env.VITE_ENV === 'test',
  pathBasename: import.meta.env.VITE_BASENAME,
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
  },
  segment: {
    writeKey: import.meta.env.VITE_SEGMENT_WRITE_KEY,
  },
};

export default config;
